module.exports = __webpack_public_path__ + "img/preciousMetals.4206fac.webp";